import React, { createContext, useContext, useState, useCallback } from 'react';
import logger from '../utils/logger';

const FamilyContext = createContext();

export const FamilyProvider = ({ children: appChildren }) => {
  const [selectedChild, setSelectedChild] = useState(null);
  const [children, setChildren] = useState([]);

  const selectChild = useCallback((child) => {
    logger.family('FamilyContext: Selecting child:', child);
    setSelectedChild(child);
  }, []);

  const updateChildren = useCallback((childrenList) => {
    logger.family('FamilyContext: Updating children:', childrenList?.length || 0);
    setChildren(childrenList || []);

    // Автоматически выбираем первого ребенка, если он один и нет выбранного
    // Используем функциональное обновление, чтобы избежать зависимости от selectedChild
    if (childrenList && childrenList.length === 1) {
      setSelectedChild(prev => {
        if (!prev) {
          logger.family('FamilyContext: Auto-selecting single child:', childrenList[0].full_name);
          return childrenList[0];
        }
        return prev;
      });
    }
  }, []);

  const clearSelectedChild = useCallback(() => {
    logger.family('FamilyContext: Clearing selected child');
    setSelectedChild(null);
  }, []);

  const value = {
    // Состояние
    selectedChild,
    children,

    // Методы
    selectChild,
    updateChildren,
    clearSelectedChild,

    // Геттеры для удобства
    hasChildren: children.length > 0,
    hasMultipleChildren: children.length > 1,
    selectedChildId: selectedChild?.id || null,
    selectedChildName: selectedChild?.full_name || null
  };

  return (
    <FamilyContext.Provider value={value}>
      {appChildren}
    </FamilyContext.Provider>
  );
};

export const useFamily = () => {
  const context = useContext(FamilyContext);
  if (!context) {
    throw new Error('useFamily must be used within a FamilyProvider');
  }
  return context;
};

export default FamilyContext;